import { render, staticRenderFns } from "./Jazb.vue?vue&type=template&id=902e84c4"
import script from "./Jazb.vue?vue&type=script&lang=js"
export * from "./Jazb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports